// @ts-nocheck
import React, { useContext, useEffect, useState, useMemo, useCallback, useRef } from 'react';
import Context from '../../context/Context';
import {
    fetchFormElements,
    fetchForm,
    createFormElement,
    editFormElement,
} from '../../context/forms/FormsAction';
import { useParams, Link, useNavigate, useLocation } from 'react-router-dom';
import { URL } from '../../service/Service';
import Element from '../../components/formElements/Element';
import Spinner from '../../components/Spinner';

import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import PreviewIcon from '@mui/icons-material/Preview';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import SearchIcon from '@mui/icons-material/Search';
import DesktopWindowsIcon from '@mui/icons-material/DesktopWindows';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

import {
    Title,
    TextRotationNone,
    CheckBox,
    ArrowDropDownCircle,
    TextFields,
    DateRange,
    Info,
    FormatListBulleted,
    Star,
    HorizontalRule,
    AttachMoney,
    Settings,
} from '@mui/icons-material';
import { jwtDecode } from 'jwt-decode';

const pageOf = (element) => Number(element?.pageNumber) || 1;

const moveElementWithinPage = (elements, pageNumber, elementId, targetPageIndex) => {
    const pageElements = elements.filter((element) => pageOf(element) === pageNumber);
    const sourcePageIndex = pageElements.findIndex((element) => element.id === elementId);

    if (sourcePageIndex < 0 || targetPageIndex < 0 || targetPageIndex >= pageElements.length) {
        return { elements, position: -1 };
    }

    const targetElement = pageElements[targetPageIndex];
    const sourceGlobalIndex = elements.findIndex((element) => element.id === elementId);
    const targetGlobalIndex = elements.findIndex((element) => element.id === targetElement.id);

    if (sourceGlobalIndex < 0 || targetGlobalIndex < 0 || sourceGlobalIndex === targetGlobalIndex) {
        return { elements, position: sourceGlobalIndex };
    }

    const next = [...elements];
    const [moved] = next.splice(sourceGlobalIndex, 1);
    next.splice(targetGlobalIndex, 0, moved);

    return {
        elements: next,
        position: next.findIndex((element) => element.id === elementId),
    };
};

const getUserRole = () => {
    try {
        const token = sessionStorage.getItem('jwt');

        if (!token) {
            return 'USER';
        }

        return jwtDecode(token)?.authorities?.[0]?.authority ?? 'USER';
    } catch (_error) {
        return 'USER';
    }
};

const extractCreatedElement = (response) => {
    return (
        response?.payload?.data ||
        response?.payload ||
        response?.data ||
        response
    );
};

const extractElementId = (element) => {
    if (!element) {
        return null;
    }

    if (typeof element === 'string') {
        return element;
    }

    return (
        element.id ||
        element.elementId ||
        element.elementID ||
        element.element_id ||
        element.formElementId ||
        element.formElementID ||
        element.form_element_id ||
        element.ID ||
        element._id ||
        null
    );
};

const normaliseElement = (element) => {
    if (!element) {
        return null;
    }

    const id = extractElementId(element);

    return {
        ...element,
        id,
        element_type:
            element.element_type ||
            element.elementType ||
            element.type ||
            element.formElementType ||
            '',
        element_value:
            element.element_value ??
            element.elementValue ??
            element.value ??
            '',
    };
};

const StepHeader = ({
                        activeStep,
                        onBack,
                        onNext,
                        nextDisabled,
                        nextHint,
                        isCreatingTemplate,
                    }) => {
    const steps = [
        { label: 'Editor', description: 'Campos do formulário' },
        { label: 'Definições', description: 'Pagamentos e regras' },
        { label: 'Upload Imagem', description: 'Marca e publicação' },
    ];

    return (
        <div className="sticky top-0 z-30 -mx-5 -mt-5 border-b border-slate-200 bg-slate-50/95 px-5 py-4 backdrop-blur">
            <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
                <div>
                    <p className="text-xs font-semibold uppercase tracking-[0.22em] text-emerald-700">
                        Criador de formulários
                    </p>

                    <h1 className="mt-1 text-2xl font-bold text-slate-900">
                        Constrói o conteúdo do formulário
                    </h1>

                    <p className="mt-1 text-sm text-slate-500">
                        Começa por um modelo ou adiciona campos manualmente. O utilizador vê a pré-visualização ao centro.
                    </p>
                </div>

                <div className="flex items-center gap-2">
                    <button
                        type="button"
                        className="rounded-xl border border-slate-300 bg-white px-4 py-2 text-sm font-semibold text-slate-700 shadow-sm transition hover:bg-slate-100"
                        onClick={onBack}
                    >
                        Voltar
                    </button>

                    <button
                        type="button"
                        className={`rounded-xl px-5 py-2 text-sm font-semibold text-white shadow-sm transition ${
                            nextDisabled || isCreatingTemplate
                                ? 'cursor-not-allowed bg-slate-400'
                                : 'bg-green-cl hover:bg-opacity-90'
                        }`}
                        onClick={onNext}
                        disabled={nextDisabled || isCreatingTemplate}
                        title={nextDisabled ? nextHint : ''}
                    >
                        Seguinte
                    </button>
                </div>
            </div>

            <div className="mt-5 grid gap-3 md:grid-cols-3">
                {steps.map((step, index) => {
                    const current = index === activeStep;
                    const done = index < activeStep;

                    return (
                        <div
                            key={step.label}
                            className={`rounded-2xl border p-4 transition ${
                                current
                                    ? 'border-emerald-700 bg-white shadow-sm'
                                    : done
                                        ? 'border-emerald-100 bg-emerald-50'
                                        : 'border-slate-200 bg-white'
                            }`}
                        >
                            <div className="flex items-center gap-3">
                                <div
                                    className={`flex h-9 w-9 items-center justify-center rounded-full text-sm font-bold ${
                                        current
                                            ? 'bg-green-cl text-white'
                                            : done
                                                ? 'bg-emerald-100 text-emerald-700'
                                                : 'bg-slate-100 text-slate-500'
                                    }`}
                                >
                                    {index + 1}
                                </div>

                                <div>
                                    <p className="text-sm font-bold text-slate-900">
                                        {step.label}
                                    </p>

                                    <p className="text-xs text-slate-500">
                                        {step.description}
                                    </p>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

const Toast = ({ type = 'info', message, onClose, actionLabel, onAction }) => {
    if (!message) {
        return null;
    }

    const styles = type === 'error'
        ? 'border-red-200 bg-red-50 text-red-700'
        : type === 'success'
            ? 'border-emerald-200 bg-emerald-50 text-emerald-700'
            : 'border-amber-200 bg-amber-50 text-amber-700';

    return (
        <div className="fixed bottom-5 right-5 z-50 w-[min(420px,calc(100vw-2rem))]">
            <div className={`rounded-2xl border px-5 py-4 shadow-xl ${styles}`}>
                <div className="flex items-start justify-between gap-4">
                    <div>
                        <p className="text-sm font-semibold">
                            {type === 'success' ? 'Concluído' : 'Atenção'}
                        </p>

                        <p className="mt-1 text-sm">
                            {message}
                        </p>
                        {actionLabel && onAction && (
                            <button type="button" className="mt-3 rounded-lg bg-emerald-800 px-3 py-1.5 text-xs font-bold text-white hover:bg-emerald-900" onClick={onAction}>
                                {actionLabel}
                            </button>
                        )}
                    </div>

                    <button
                        type="button"
                        className="text-lg leading-none opacity-70 hover:opacity-100"
                        onClick={onClose}
                        aria-label="Fechar mensagem"
                    >
                        ×
                    </button>
                </div>
            </div>
        </div>
    );
};

const ConfirmDialog = ({ open, fieldName, onCancel, onConfirm }) => {
    if (!open) return null;

    return (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-slate-950/50 p-4 backdrop-blur-sm" role="presentation" onMouseDown={onCancel}>
            <div className="w-full max-w-md rounded-3xl bg-white p-6 shadow-2xl" role="dialog" aria-modal="true" aria-labelledby="delete-field-title" onMouseDown={(event) => event.stopPropagation()}>
                <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-red-50 text-red-600">
                    <DeleteOutlineIcon />
                </div>
                <h2 id="delete-field-title" className="mt-4 text-xl font-bold text-slate-900">Remover este campo?</h2>
                <p className="mt-2 text-sm leading-6 text-slate-600">
                    O campo <strong>{fieldName || 'selecionado'}</strong> será removido. Podes desfazer a ação logo a seguir.
                </p>
                <div className="mt-6 flex justify-end gap-3">
                    <button type="button" className="rounded-xl border border-slate-300 px-4 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50" onClick={onCancel}>Cancelar</button>
                    <button type="button" className="rounded-xl bg-red-600 px-4 py-2 text-sm font-semibold text-white hover:bg-red-700" onClick={onConfirm}>Remover campo</button>
                </div>
            </div>
        </div>
    );
};

const ConfirmPageDeleteDialog = ({ open, pageNumber, fieldCount, onCancel, onConfirm }) => {
    if (!open) return null;

    return (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-slate-950/50 p-4 backdrop-blur-sm" role="presentation" onMouseDown={onCancel}>
            <div className="w-full max-w-md rounded-3xl bg-white p-6 shadow-2xl" role="dialog" aria-modal="true" aria-labelledby="delete-page-title" aria-describedby="delete-page-description" onMouseDown={(event) => event.stopPropagation()}>
                <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-red-50 text-red-600">
                    <DeleteOutlineIcon />
                </div>
                <h2 id="delete-page-title" className="mt-4 text-xl font-bold text-slate-900">Remover a Página {pageNumber}?</h2>
                <p id="delete-page-description" className="mt-2 text-sm leading-6 text-slate-600">
                    {fieldCount > 0
                        ? <>Esta página contém <strong>{fieldCount} {fieldCount === 1 ? 'campo' : 'campos'}</strong>. Ao remover a página, {fieldCount === 1 ? 'esse campo também será eliminado' : 'esses campos também serão eliminados'}.</>
                        : 'Esta página está vazia e será removida do formulário.'}
                </p>
                <p className="mt-3 rounded-xl bg-red-50 px-4 py-3 text-sm font-semibold text-red-700">Esta ação não pode ser desfeita.</p>
                <div className="mt-6 flex justify-end gap-3">
                    <button type="button" className="rounded-xl border border-slate-300 px-4 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50" onClick={onCancel}>Cancelar</button>
                    <button type="button" className="rounded-xl bg-red-600 px-4 py-2 text-sm font-semibold text-white hover:bg-red-700" onClick={onConfirm}>Remover página</button>
                </div>
            </div>
        </div>
    );
};

const FieldButton = ({ element, onClick, disabled }) => (
    <button
        type="button"
        className="group flex w-full items-center gap-2.5 rounded-xl border border-transparent bg-transparent px-2 py-2 text-left transition hover:border-emerald-100 hover:bg-emerald-50 disabled:cursor-not-allowed disabled:opacity-60"
        onClick={onClick}
        disabled={disabled}
    >
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-slate-100 text-slate-600 transition group-hover:bg-white group-hover:text-emerald-700">
            {element.icon}
        </span>

        <span>
            <span className="block text-[13px] font-semibold leading-4 text-slate-800">
                {element.name}
            </span>

            <span className="mt-0.5 block text-[11px] leading-4 text-slate-500">
                {element.description}
            </span>
        </span>
    </button>
);

const SummaryItem = ({ ok, label }) => (
    <div className="flex items-center justify-between rounded-xl bg-slate-50 px-3 py-2 text-sm">
        <span className="text-slate-600">
            {label}
        </span>

        <span
            className={`rounded-full px-2 py-0.5 text-xs font-bold ${
                ok
                    ? 'bg-emerald-100 text-emerald-700'
                    : 'bg-red-100 text-red-700'
            }`}
        >
            {ok ? 'OK' : 'Falta'}
        </span>
    </div>
);

const FormWizard1 = () => {
    const { idform } = useParams();
    const { state, dispatch } = useContext(Context);
    const { loading, data } = state.formelements;

    const createElementURL = `${URL}/api/forms/${idform}/formelements`;

    const [formElements, setFormElements] = useState([]);
    const formElementsRef = useRef([]);
    const [showNav, setShowNav] = useState(true);
    const [toast, setToast] = useState('');
    const [toastType, setToastType] = useState('info');
    const [draggedIndex, setDraggedIndex] = useState(null);
    const [draggedElementId, setDraggedElementId] = useState(null);
    const [isCreatingTemplate, setIsCreatingTemplate] = useState(false);
    const [fieldSearch, setFieldSearch] = useState('');
    const [previewMode, setPreviewMode] = useState('desktop');
    const [activePage, setActivePage] = useState(1);
    const [minimumPageCount, setMinimumPageCount] = useState(1);
    const [saveStatus, setSaveStatus] = useState('saved');
    const [pendingDelete, setPendingDelete] = useState(null);
    const [pendingPageDelete, setPendingPageDelete] = useState(null);
    const [undoDelete, setUndoDelete] = useState(null);
    const [showOnboarding, setShowOnboarding] = useState(() => localStorage.getItem('euforms-builder-intro-seen') !== 'true');

    const navigate = useNavigate();
    const userRole = getUserRole();
    const location = useLocation();

    const isAdmin = userRole === 'ADMIN';
    const baseFormPath = isAdmin ? `/admin/forms/${idform}` : `/forms/${idform}`;
    const formsListPath = `${isAdmin ? '/admin/forms' : '/forms'}?form=${encodeURIComponent(idform)}`;

    const ELEMENT_GROUPS = [
        {
            title: 'Campos básicos',
            items: [
                {
                    name: 'Título',
                    type: 'title',
                    icon: <Title />,
                    description: 'Secção ou cabeçalho',
                },
                {
                    name: 'Texto curto',
                    type: 'input',
                    icon: <TextRotationNone />,
                    description: 'Nome, email, telefone',
                },
                {
                    name: 'Comentário',
                    type: 'multiline',
                    icon: <TextFields />,
                    description: 'Resposta longa',
                },
                {
                    name: 'Data',
                    type: 'datepicker',
                    icon: <DateRange />,
                    description: 'Data do evento ou marcação',
                },
            ],
        },
        {
            title: 'Escolhas',
            items: [
                {
                    name: 'Caixa de Validação',
                    type: 'checkbox',
                    icon: <CheckBox />,
                    description: 'Aceitação ou confirmação',
                },
                {
                    name: 'Caixa de Seleção',
                    type: 'select',
                    icon: <ArrowDropDownCircle />,
                    description: 'Lista de opções',
                },
                {
                    name: 'Escolha Múltipla',
                    type: 'choose',
                    icon: <FormatListBulleted />,
                    description: 'Várias opções visíveis',
                },
                {
                    name: 'Avaliação',
                    type: 'rating',
                    icon: <Star />,
                    description: 'Pontuação por estrelas',
                },
            ],
        },
        {
            title: 'Pagamento e estrutura',
            items: [
                {
                    name: 'Pagamento',
                    type: 'payment',
                    icon: <AttachMoney />,
                    description: 'Checkout único do formulário',
                },
                {
                    name: 'Campo de Preço',
                    type: 'price',
                    icon: <AttachMoney />,
                    description: 'Produto, bilhete ou inscrição',
                },
                {
                    name: 'Campo de Doação',
                    type: 'donation',
                    icon: <AttachMoney />,
                    description: 'Valor livre',
                },
                {
                    name: 'Informação',
                    type: 'textblock',
                    icon: <Info />,
                    description: 'Texto explicativo',
                },
                {
                    name: 'Linha de Divisão',
                    type: 'divider',
                    icon: <HorizontalRule />,
                    description: 'Separador visual',
                },
            ],
        },
    ];

    const PAGE_TEMPLATES = [
        {
            title: 'Inscrição em workshop',
            description: 'Cria nesta página a inscrição, participante e bilhete.',
            badge: 'Formação',
            image: '/template-assets/workshop-criativo.png',
            fields: [
                {
                    type: 'title',
                    label: 'Inscrição em workshop',
                    placeholder: 'Preenche os dados abaixo para reservares a tua inscrição.',
                },
                {
                    type: 'input',
                    label: 'Nome completo',
                    placeholder: 'Ex.: Ana Silva',
                    required: true,
                    regex: 'TEXT',
                },
                {
                    type: 'input',
                    label: 'Email',
                    placeholder: 'Ex.: nome@exemplo.pt',
                    required: true,
                    regex: 'EMAIL',
                },
                {
                    type: 'datepicker',
                    label: 'Data pretendida',
                    placeholder: 'Seleciona a data do workshop',
                    required: true,
                },
                {
                    type: 'price',
                    label: 'Bilhete do workshop',
                    placeholder: 'Seleciona a quantidade de bilhetes',
                    required: true,
                    cost: 45,
                    stock: 30,
                    maxQuantityPerElement: 4,
                    imageAsset: '/template-assets/workshop-criativo.png',
                },
            ],
        },
        {
            title: 'Dados do cliente',
            description: 'Nome, email e notas para uma etapa de identificação.',
            badge: 'Identificação',
            image: '/template-assets/marcacao-bem-estar.png',
            fields: [
                {
                    type: 'title',
                    label: 'Os teus dados',
                    placeholder: 'Preenche os dados necessários para continuarmos.',
                },
                {
                    type: 'input',
                    label: 'Nome completo',
                    placeholder: 'Ex.: João Silva',
                    required: true,
                    regex: 'TEXT',
                },
                {
                    type: 'input',
                    label: 'Email',
                    placeholder: 'Ex.: nome@exemplo.pt',
                    required: true,
                    regex: 'EMAIL',
                },
                {
                    type: 'multiline',
                    label: 'Mensagem',
                    placeholder: 'Escreve aqui a tua mensagem.',
                    required: true,
                    regex: 'TEXT',
                },
            ],
        },
        {
            title: 'Donativo',
            description: 'História da causa, identificação e contribuição livre.',
            badge: 'Solidário',
            image: '/template-assets/campanha-solidaria.png',
            fields: [
                {
                    type: 'title',
                    label: 'Fazer um donativo',
                    placeholder: 'O teu contributo ajuda-nos a continuar este projeto.',
                },
                {
                    type: 'input',
                    label: 'Nome completo',
                    placeholder: 'Ex.: Maria Costa',
                    required: true,
                    regex: 'TEXT',
                },
                {
                    type: 'input',
                    label: 'Email',
                    placeholder: 'Ex.: nome@exemplo.pt',
                    required: true,
                    regex: 'EMAIL',
                },
                {
                    type: 'donation',
                    label: 'Valor do donativo',
                    placeholder: 'Indica o valor que pretendes doar',
                    required: true,
                    donation: 0,
                },
            ],
        },
        {
            title: 'Bilhetes de evento',
            description: 'Adiciona uma secção pronta para vender bilhetes nesta página.',
            badge: 'Eventos',
            image: '/template-assets/evento-musica.png',
            fields: [
                { type: 'title', label: 'Escolhe os teus bilhetes', placeholder: 'Seleciona o tipo de acesso e a quantidade pretendida.' },
                { type: 'price', label: 'Bilhete diário', placeholder: 'Acesso ao evento durante um dia.', cost: 35, stock: 250, maxQuantityPerElement: 6, imageAsset: '/template-assets/evento-musica.png' },
                { type: 'price', label: 'Passe completo', placeholder: 'Acesso a todos os dias do evento.', cost: 79, stock: 120, maxQuantityPerElement: 6, imageAsset: '/template-assets/evento-musica.png' },
            ],
        },
        {
            title: 'Catálogo de produtos',
            description: 'Cria uma pequena montra com produtos, imagens e stock.',
            badge: 'E-commerce',
            image: '/template-assets/loja-artesanal.png',
            fields: [
                { type: 'title', label: 'Os nossos produtos', placeholder: 'Escolhe os artigos e as quantidades.' },
                { type: 'price', label: 'Caixa presente', placeholder: 'Uma seleção artesanal pronta a oferecer.', cost: 49.9, stock: 40, maxQuantityPerElement: 5, imageAsset: '/template-assets/loja-artesanal.png' },
                { type: 'price', label: 'Caneca artesanal', placeholder: 'Cerâmica de acabamento natural.', cost: 18.5, stock: 60, maxQuantityPerElement: 8, imageAsset: '/template-assets/loja-artesanal.png' },
            ],
        },
        {
            title: 'Encomenda de refeições', description: 'Menu pronto com imagens, preços e quantidades.', badge: 'Restauração', image: '/template-assets/encomenda-restaurante.png',
            fields: [
                { type: 'title', label: 'Escolhe a tua refeição', placeholder: 'Seleciona os pratos e as quantidades para a encomenda.' },
                { type: 'price', label: 'Menu mediterrânico', placeholder: 'Salada fresca, sopa e bebida natural.', cost: 14.9, stock: 60, maxQuantityPerElement: 8, imageAsset: '/template-assets/encomenda-restaurante.png' },
                { type: 'price', label: 'Sanduíche artesanal', placeholder: 'Preparada no próprio dia com ingredientes frescos.', cost: 8.5, stock: 80, maxQuantityPerElement: 8, imageAsset: '/template-assets/encomenda-restaurante.png' },
            ],
        },
        {
            title: 'Inscrição desportiva', description: 'Participante e inscrição para corrida ou caminhada.', badge: 'Desporto', image: '/template-assets/prova-desportiva.png',
            fields: [
                { type: 'title', label: 'Inscrição na prova', placeholder: 'Reserva o teu lugar e prepara-te para o desafio.' },
                { type: 'input', label: 'Nome do participante', placeholder: 'Ex.: Marta Ferreira', required: true, regex: 'TEXT' },
                { type: 'datepicker', label: 'Data de nascimento', placeholder: 'Seleciona a data', required: true },
                { type: 'price', label: 'Inscrição individual', placeholder: 'Inclui dorsal e seguro desportivo.', cost: 15, stock: 500, maxQuantityPerElement: 5, imageAsset: '/template-assets/prova-desportiva.png' },
            ],
        },
        {
            title: 'Reserva de alojamento', description: 'Datas, hóspedes e quarto numa secção pronta.', badge: 'Turismo', image: '/template-assets/reserva-alojamento.png',
            fields: [
                { type: 'title', label: 'Reserva a tua estadia', placeholder: 'Escolhe a data e o quarto para uma escapadinha junto ao mar.' },
                { type: 'datepicker', label: 'Data de entrada', placeholder: 'Seleciona a data de chegada', required: true },
                { type: 'price', label: 'Quarto duplo', placeholder: 'Preço por noite, pequeno-almoço incluído.', cost: 95, stock: 12, maxQuantityPerElement: 3, imageAsset: '/template-assets/reserva-alojamento.png' },
            ],
        },
    ];

    const COMPLETE_TEMPLATES = [
        {
            title: 'Festival de música', description: 'Bilhetes, participante e pagamento em 2 páginas.', badge: 'Eventos', image: '/template-assets/evento-musica.png', pages: 2,
            fields: [
                { type: 'title', pageNumber: 1, label: 'Festival ao pôr do sol', placeholder: 'Escolhe os teus bilhetes e prepara-te para uma noite inesquecível.' },
                { type: 'price', pageNumber: 1, label: 'Bilhete diário', placeholder: 'Acesso ao recinto durante um dia.', cost: 35, stock: 250, maxQuantityPerElement: 6, imageAsset: '/template-assets/evento-musica.png' },
                { type: 'price', pageNumber: 1, label: 'Passe completo', placeholder: 'Acesso a todos os dias do festival.', cost: 79, stock: 120, maxQuantityPerElement: 6, imageAsset: '/template-assets/evento-musica.png' },
                { type: 'title', pageNumber: 2, label: 'Dados do participante', placeholder: 'Indica os dados da pessoa responsável pela compra.' },
                { type: 'input', pageNumber: 2, label: 'Nome completo', placeholder: 'Ex.: Ana Silva', required: true, regex: 'TEXT' },
                { type: 'input', pageNumber: 2, label: 'Email', placeholder: 'Ex.: nome@exemplo.pt', required: true, regex: 'EMAIL' },
                { type: 'checkbox', pageNumber: 2, label: 'Aceito os termos e condições do evento', required: true },
                { type: 'payment', pageNumber: 2, label: 'Pagamento' },
            ],
        },
        {
            title: 'Workshop criativo', description: 'Sessão, participante e inscrição paga em 2 páginas.', badge: 'Formação', image: '/template-assets/workshop-criativo.png', pages: 2,
            fields: [
                { type: 'title', pageNumber: 1, label: 'Workshop criativo', placeholder: 'Uma sessão prática para transformar ideias em projetos.' },
                { type: 'datepicker', pageNumber: 1, label: 'Data pretendida', placeholder: 'Escolhe a data da sessão', required: true },
                { type: 'price', pageNumber: 1, label: 'Inscrição individual', placeholder: 'Inclui materiais e certificado.', cost: 45, stock: 30, maxQuantityPerElement: 4, imageAsset: '/template-assets/workshop-criativo.png' },
                { type: 'title', pageNumber: 2, label: 'A tua inscrição', placeholder: 'Só precisamos dos dados essenciais para confirmar o lugar.' },
                { type: 'input', pageNumber: 2, label: 'Nome completo', placeholder: 'Ex.: João Martins', required: true, regex: 'TEXT' },
                { type: 'input', pageNumber: 2, label: 'Email', placeholder: 'Ex.: nome@exemplo.pt', required: true, regex: 'EMAIL' },
                { type: 'multiline', pageNumber: 2, label: 'Objetivos ou necessidades', placeholder: 'Conta-nos o que gostarias de aprender.' },
                { type: 'payment', pageNumber: 2, label: 'Pagamento' },
            ],
        },
        {
            title: 'Campanha solidária', description: 'História, identificação e donativo livre em 2 páginas.', badge: 'Solidário', image: '/template-assets/campanha-solidaria.png', pages: 2,
            fields: [
                { type: 'title', pageNumber: 1, label: 'Juntos plantamos o futuro', placeholder: 'Cada contributo ajuda a recuperar espaços verdes da comunidade.' },
                { type: 'textblock', pageNumber: 1, label: 'O teu impacto', placeholder: 'O valor angariado financia árvores, ferramentas e ações de voluntariado.' },
                { type: 'donation', pageNumber: 1, label: 'Valor do donativo', placeholder: 'Escolhe o valor que pretendes contribuir.', donation: 20, required: true },
                { type: 'title', pageNumber: 2, label: 'Dados do doador', placeholder: 'Indica os dados para receberes a confirmação.' },
                { type: 'input', pageNumber: 2, label: 'Nome completo', placeholder: 'Ex.: Maria Costa', required: true, regex: 'TEXT' },
                { type: 'input', pageNumber: 2, label: 'Email', placeholder: 'Ex.: nome@exemplo.pt', required: true, regex: 'EMAIL' },
                { type: 'payment', pageNumber: 2, label: 'Pagamento' },
            ],
        },
        {
            title: 'Loja de produtos', description: 'Catálogo, entrega e checkout completo em 3 páginas.', badge: 'E-commerce', image: '/template-assets/loja-artesanal.png', pages: 3,
            fields: [
                { type: 'title', pageNumber: 1, label: 'Coleção artesanal', placeholder: 'Produtos úteis, sustentáveis e preparados com cuidado.' },
                { type: 'price', pageNumber: 1, label: 'Caixa presente', placeholder: 'Caneca, café, vela e saco em tecido.', cost: 49.9, stock: 40, maxQuantityPerElement: 5, imageAsset: '/template-assets/loja-artesanal.png' },
                { type: 'price', pageNumber: 1, label: 'Caneca artesanal', placeholder: 'Cerâmica de acabamento natural.', cost: 18.5, stock: 60, maxQuantityPerElement: 8, imageAsset: '/template-assets/loja-artesanal.png' },
                { type: 'title', pageNumber: 2, label: 'Dados de entrega', placeholder: 'Diz-nos onde devemos entregar a encomenda.' },
                { type: 'input', pageNumber: 2, label: 'Nome completo', placeholder: 'Ex.: Sofia Almeida', required: true, regex: 'TEXT' },
                { type: 'input', pageNumber: 2, label: 'Email', placeholder: 'Ex.: nome@exemplo.pt', required: true, regex: 'EMAIL' },
                { type: 'multiline', pageNumber: 2, label: 'Morada de entrega', placeholder: 'Rua, número, código postal e localidade.', required: true },
                { type: 'title', pageNumber: 3, label: 'Rever e pagar', placeholder: 'Confirma a encomenda e escolhe a forma de pagamento.' },
                { type: 'checkbox', pageNumber: 3, label: 'Confirmo que os dados da encomenda estão corretos', required: true },
                { type: 'payment', pageNumber: 3, label: 'Pagamento' },
            ],
        },
        {
            title: 'Marcação de serviço', description: 'Serviço, agenda, contacto e sinal em 2 páginas.', badge: 'Reservas', image: '/template-assets/marcacao-bem-estar.png', pages: 2,
            fields: [
                { type: 'title', pageNumber: 1, label: 'Marca o teu momento', placeholder: 'Escolhe o serviço e a data mais conveniente.' },
                { type: 'price', pageNumber: 1, label: 'Sessão de bem-estar', placeholder: 'Sessão individual de 60 minutos.', cost: 55, stock: 50, maxQuantityPerElement: 1, imageAsset: '/template-assets/marcacao-bem-estar.png' },
                { type: 'datepicker', pageNumber: 1, label: 'Data pretendida', placeholder: 'Seleciona uma data', required: true },
                { type: 'title', pageNumber: 2, label: 'Confirmar marcação', placeholder: 'Preenche os teus dados para concluíres a reserva.' },
                { type: 'input', pageNumber: 2, label: 'Nome completo', placeholder: 'Ex.: Rui Pereira', required: true, regex: 'TEXT' },
                { type: 'input', pageNumber: 2, label: 'Email', placeholder: 'Ex.: nome@exemplo.pt', required: true, regex: 'EMAIL' },
                { type: 'multiline', pageNumber: 2, label: 'Notas para a sessão', placeholder: 'Partilha alguma preferência ou necessidade.' },
                { type: 'payment', pageNumber: 2, label: 'Pagamento' },
            ],
        },
        {
            title: 'Take-away', description: 'Menu, entrega e pagamento em 3 páginas.', badge: 'Restauração', image: '/template-assets/encomenda-restaurante.png', pages: 3,
            fields: [
                { type: 'title', pageNumber: 1, label: 'Menu do dia', placeholder: 'Escolhe os teus pratos favoritos.' },
                { type: 'price', pageNumber: 1, label: 'Menu mediterrânico', placeholder: 'Salada fresca, sopa e bebida natural.', cost: 14.9, stock: 60, maxQuantityPerElement: 8, imageAsset: '/template-assets/encomenda-restaurante.png' },
                { type: 'price', pageNumber: 1, label: 'Sanduíche artesanal', placeholder: 'Preparada com ingredientes frescos.', cost: 8.5, stock: 80, maxQuantityPerElement: 8, imageAsset: '/template-assets/encomenda-restaurante.png' },
                { type: 'title', pageNumber: 2, label: 'Entrega ou recolha', placeholder: 'Indica os dados para prepararmos a encomenda.' },
                { type: 'input', pageNumber: 2, label: 'Nome completo', placeholder: 'Ex.: Pedro Santos', required: true, regex: 'TEXT' },
                { type: 'input', pageNumber: 2, label: 'Email', placeholder: 'Ex.: nome@exemplo.pt', required: true, regex: 'EMAIL' },
                { type: 'multiline', pageNumber: 2, label: 'Morada ou notas', placeholder: 'Morada de entrega, alergias ou observações.' },
                { type: 'title', pageNumber: 3, label: 'Confirmar encomenda', placeholder: 'Revê o pedido e conclui o pagamento.' },
                { type: 'payment', pageNumber: 3, label: 'Pagamento' },
            ],
        },
        {
            title: 'Corrida solidária', description: 'Inscrição, participante e pagamento em 2 páginas.', badge: 'Desporto', image: '/template-assets/prova-desportiva.png', pages: 2,
            fields: [
                { type: 'title', pageNumber: 1, label: 'Corrida pela comunidade', placeholder: 'Participa numa manhã de desporto e solidariedade.' },
                { type: 'price', pageNumber: 1, label: 'Inscrição 10 km', placeholder: 'Inclui dorsal, seguro e abastecimento.', cost: 15, stock: 500, maxQuantityPerElement: 5, imageAsset: '/template-assets/prova-desportiva.png' },
                { type: 'price', pageNumber: 1, label: 'Caminhada 5 km', placeholder: 'Percurso acessível para toda a família.', cost: 8, stock: 500, maxQuantityPerElement: 8, imageAsset: '/template-assets/prova-desportiva.png' },
                { type: 'title', pageNumber: 2, label: 'Dados do participante', placeholder: 'Preenche os dados para concluíres a inscrição.' },
                { type: 'input', pageNumber: 2, label: 'Nome completo', placeholder: 'Ex.: Marta Ferreira', required: true, regex: 'TEXT' },
                { type: 'input', pageNumber: 2, label: 'Email', placeholder: 'Ex.: nome@exemplo.pt', required: true, regex: 'EMAIL' },
                { type: 'datepicker', pageNumber: 2, label: 'Data de nascimento', placeholder: 'Seleciona a data', required: true },
                { type: 'payment', pageNumber: 2, label: 'Pagamento' },
            ],
        },
        {
            title: 'Alojamento local', description: 'Quarto, hóspede e reserva paga em 3 páginas.', badge: 'Turismo', image: '/template-assets/reserva-alojamento.png', pages: 3,
            fields: [
                { type: 'title', pageNumber: 1, label: 'Escapadinha junto ao mar', placeholder: 'Escolhe o quarto ideal para a tua estadia.' },
                { type: 'price', pageNumber: 1, label: 'Quarto duplo', placeholder: 'Preço por noite, pequeno-almoço incluído.', cost: 95, stock: 12, maxQuantityPerElement: 3, imageAsset: '/template-assets/reserva-alojamento.png' },
                { type: 'datepicker', pageNumber: 1, label: 'Data de entrada', placeholder: 'Seleciona a data de chegada', required: true },
                { type: 'title', pageNumber: 2, label: 'Dados do hóspede', placeholder: 'Indica os dados da pessoa responsável pela reserva.' },
                { type: 'input', pageNumber: 2, label: 'Nome completo', placeholder: 'Ex.: Inês Carvalho', required: true, regex: 'TEXT' },
                { type: 'input', pageNumber: 2, label: 'Email', placeholder: 'Ex.: nome@exemplo.pt', required: true, regex: 'EMAIL' },
                { type: 'multiline', pageNumber: 2, label: 'Pedidos especiais', placeholder: 'Horário de chegada ou outras necessidades.' },
                { type: 'title', pageNumber: 3, label: 'Confirmar reserva', placeholder: 'Revê os dados e conclui o pagamento.' },
                { type: 'payment', pageNumber: 3, label: 'Pagamento' },
            ],
        },
    ];

    const filteredElementGroups = (() => {
        const query = fieldSearch.trim().toLocaleLowerCase('pt');
        if (!query) return ELEMENT_GROUPS;
        return ELEMENT_GROUPS.map((group) => ({
            ...group,
            items: group.items.filter((item) =>
                `${item.name} ${item.description}`.toLocaleLowerCase('pt').includes(query),
            ),
        })).filter((group) => group.items.length > 0);
    })();

    useEffect(() => {
        const isAdminPath = location.pathname.startsWith('/admin/forms/');
        const isFormWizard1Path = location.pathname.endsWith('/formwizard/1');

        if (isAdminPath && isFormWizard1Path && userRole !== 'ADMIN') {
            navigate('/login');
        }
    }, [location.pathname, navigate, userRole]);

    useEffect(() => {
        const url = `${URL}/api/forms/${idform}/formelements`;
        const urlForm = `${URL}/api/forms/${idform}`;

        async function fetchData() {
            await fetchFormElements(url, {}, dispatch);
            await fetchForm(urlForm, {}, dispatch);
        }

        fetchData();
    }, [dispatch, idform]);

    useEffect(() => {
        const normalisedElements = Object.values(data ?? {})
            .map(normaliseElement)
            .filter(Boolean);

        setFormElements(normalisedElements);
    }, [data]);

    useEffect(() => {
        formElementsRef.current = formElements;
    }, [formElements]);

    const hasPaymentElement = useMemo(() => {
        return formElements.some((element) => {
            return element.element_type === 'price' || element.element_type === 'donation';
        });
    }, [formElements]);

    const hasElements = formElements.length > 0;

    const nextDisabled = !hasElements;

    const nextHint = !hasElements
        ? 'Adiciona pelo menos um campo ao formulário.'
        : '';

    useEffect(() => {
        const preventExitWhileSaving = (event) => {
            if (saveStatus !== 'saving') return;
            event.preventDefault();
            event.returnValue = '';
        };
        window.addEventListener('beforeunload', preventExitWhileSaving);
        return () => window.removeEventListener('beforeunload', preventExitWhileSaving);
    }, [saveStatus]);

    useEffect(() => {
        if (!pendingDelete) return undefined;
        const closeOnEscape = (event) => {
            if (event.key === 'Escape') setPendingDelete(null);
        };
        window.addEventListener('keydown', closeOnEscape);
        return () => window.removeEventListener('keydown', closeOnEscape);
    }, [pendingDelete]);

    const dismissOnboarding = () => {
        localStorage.setItem('euforms-builder-intro-seen', 'true');
        setShowOnboarding(false);
    };

    const handleChange = useCallback((inputId, event) => {
        setFormElements((prevFormElements) =>
            prevFormElements.map((item) => {
                if (inputId !== item.id) {
                    return item;
                }

                switch (item.element_type) {
                    case 'checkbox':
                        return {
                            ...item,
                            element_value: event.target.checked,
                        };

                    case 'datepicker':
                        return {
                            ...item,
                            element_value: event,
                        };

                    default:
                        return {
                            ...item,
                            element_value: event?.target?.value ?? event,
                        };
                }
            }),
        );
    }, []);

    const memoizedValue = useMemo(() => ({ handleChange }), [handleChange]);

    const updateHandler = useCallback((position, elementId) => {
        if (!elementId && elementId !== 0) {
            setToastType('error');
            setToast('Não foi possível ordenar: o campo não tem identificador válido.');
            return;
        }

        const url = `${URL}/api/forms/${idform}`;

        const request = {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
                Accept: 'application/json',
            },
            body: JSON.stringify({
                position,
                elementId,
            }),
        };

        setSaveStatus('saving');
        return editFormElement(url, request, dispatch)
            .then((response) => {
                setSaveStatus('saved');
                return response;
            })
            .catch((error) => {
                setSaveStatus('error');
                throw error;
            });
    }, [dispatch, idform]);

    const deleteHandler = useCallback((elementId) => {
        if (!elementId && elementId !== 0) {
            setToastType('error');
            setToast('Não foi possível remover: o campo não tem identificador válido.');
            return Promise.reject(new Error('O campo não tem identificador válido.'));
        }

        const url = `${URL}/api/forms/${idform}/formelements/${elementId}`;

        const request = {
            method: 'DELETE',
            headers: {
                'Content-type': 'application/json',
                Accept: 'application/json',
            },
        };

        return editFormElement(url, request, dispatch);
    }, [dispatch, idform]);

    const reloadElements = useCallback(async () => {
        const url = `${URL}/api/forms/${idform}/formelements`;
        await fetchFormElements(url, {}, dispatch);
    }, [dispatch, idform]);

    const createElementAsync = useCallback(async (elementType, shouldRedirect = true, targetPage = activePage) => {
        const request = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            body: JSON.stringify({
                type: elementType,
                pageNumber: targetPage,
            }),
        };

        setSaveStatus('saving');
        const response = await createFormElement(createElementURL, request, dispatch);
        const normalisedElement = normaliseElement(extractCreatedElement(response));
        const newElementId = normalisedElement?.id;

        if (!normalisedElement || !newElementId) {
            await reloadElements();
            setSaveStatus('error');
            throw new Error('O campo foi criado sem um identificador válido. A lista foi recarregada.');
        }

        setFormElements((prev) => prev.some((item) => item.id === newElementId)
            ? prev.map((item) => item.id === newElementId ? normalisedElement : item)
            : [...prev, normalisedElement]);
        setSaveStatus('saved');

        if (shouldRedirect && !['divider', 'payment'].includes(normalisedElement.element_type)) {
            navigate(`${baseFormPath}/formelements/${newElementId}/wizard`);
        }
        return normalisedElement;
    }, [activePage, baseFormPath, createElementURL, dispatch, navigate, reloadElements]);

    const uploadTemplateProductImage = useCallback(async (elementId, assetPath) => {
        const assetResponse = await fetch(assetPath);
        if (!assetResponse.ok) throw new Error('Não foi possível carregar a imagem do modelo.');
        const blob = await assetResponse.blob();
        const data = new FormData();
        data.append('file', new File([blob], assetPath.split('/').pop() || 'produto.png', { type: blob.type || 'image/png' }));
        const response = await fetch(`${URL}/api/forms/${idform}/products/${elementId}/image`, {
            method: 'POST',
            headers: { Authorization: `Bearer ${sessionStorage.getItem('jwt')}` },
            body: data,
        });
        if (!response.ok) throw new Error('Não foi possível associar a imagem ao produto do modelo.');
    }, [idform]);

    const copyElementConfiguration = useCallback(async (source, targetId) => {
        const request = {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
                label: source.label ?? '',
                required: String(Boolean(source.required)),
                element_option: source.element_option ?? [],
                selection: String(Boolean(source.selection)),
                value: source.element_value ?? '',
                photo: source.photo ?? '',
                placeholder: source.placeholder ?? '',
                cost: String(source.cost ?? 0),
                donation: String(source.donation ?? 0),
                regex: source.regex ?? 'EMPTY',
                stock: String(source.stock ?? 0),
                maxQuantityPerElement: String(source.maxQuantityPerElement ?? 0),
                pageNumber: String(source.pageNumber ?? activePage),
            }),
        };
        return editFormElement(`${URL}/api/forms/${idform}/formelements/${targetId}`, request, dispatch);
    }, [activePage, dispatch, idform]);

    const pageCount = Math.max(minimumPageCount, ...formElements.map((element) => Number(element.pageNumber) || 1));
    const visibleElements = formElements.filter((element) => (Number(element.pageNumber) || 1) === activePage);
    const addPage = () => {
        if (pageCount >= 3) {
            setToastType('info');
            setToast('Cada formulário pode ter no máximo 3 páginas.');
            return;
        }
        setMinimumPageCount(pageCount + 1);
        setActivePage(pageCount + 1);
    };

    const removeActivePage = () => {
        if (pageCount <= 1) {
            setToastType('info');
            setToast('O formulário tem de manter pelo menos uma página.');
            return;
        }

        const pageToRemove = activePage;
        const elementsToRemove = formElements.filter(
            (element) => (Number(element.pageNumber) || 1) === pageToRemove,
        );
        setPendingPageDelete({ pageNumber: pageToRemove, elements: elementsToRemove });
    };

    const confirmRemovePage = async () => {
        if (!pendingPageDelete) return;
        const pageToRemove = pendingPageDelete.pageNumber;
        const elementsToRemove = pendingPageDelete.elements;
        setPendingPageDelete(null);

        setSaveStatus('saving');
        try {
            for (const element of elementsToRemove) {
                await deleteHandler(element.id);
            }

            const elementsToRenumber = formElements.filter(
                (element) => (Number(element.pageNumber) || 1) > pageToRemove,
            );
            for (const element of elementsToRenumber) {
                await editFormElement(`${URL}/api/forms/${idform}/formelements/${element.id}`, {
                    method: 'PATCH',
                    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                    body: JSON.stringify({ pageNumber: String((Number(element.pageNumber) || 1) - 1) }),
                }, dispatch);
            }

            setFormElements((items) => items
                .filter((element) => (Number(element.pageNumber) || 1) !== pageToRemove)
                .map((element) => (Number(element.pageNumber) || 1) > pageToRemove
                    ? { ...element, pageNumber: (Number(element.pageNumber) || 1) - 1 }
                    : element));
            setMinimumPageCount(Math.max(1, pageCount - 1));
            setActivePage(Math.min(pageToRemove, pageCount - 1));
            setSaveStatus('saved');
            setToastType('success');
            setToast(`Página ${pageToRemove} removida.`);
        } catch (error) {
            await reloadElements();
            setSaveStatus('error');
            setToastType('error');
            setToast(error instanceof Error ? error.message : 'Não foi possível remover a página.');
        }
    };

    const moveElementToPage = async (element, pageNumber) => {
        setSaveStatus('saving');
        try {
            await editFormElement(`${URL}/api/forms/${idform}/formelements/${element.id}`, {
                method: 'PATCH', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ pageNumber: String(pageNumber) }),
            }, dispatch);
            setFormElements((items) => items.map((item) => item.id === element.id ? { ...item, pageNumber } : item));
            setSaveStatus('saved');
        } catch (_error) {
            setSaveStatus('error');
            setToastType('error');
            setToast('Não foi possível mover o campo para outra página.');
        }
    };

    const duplicateElement = useCallback(async (element) => {
        setSaveStatus('saving');
        try {
            const created = await createElementAsync(element.element_type, false);
            if (!created?.id) throw new Error('Não foi possível criar a cópia.');
            const updated = normaliseElement(await copyElementConfiguration(element, created.id));
            setFormElements((previous) => previous.map((item) => item.id === created.id ? { ...created, ...updated, id: created.id } : item));
            setSaveStatus('saved');
            setToastType('success');
            setToast('Campo duplicado e guardado.');
        } catch (error) {
            setSaveStatus('error');
            setToastType('error');
            setToast(error instanceof Error ? error.message : 'Não foi possível duplicar o campo.');
        }
    }, [copyElementConfiguration, createElementAsync]);

    const createElement = useCallback((elementType) => {
        if (elementType === 'payment' && formElements.some((element) => element.element_type === 'payment')) {
            setToastType('info');
            setToast('Só podes adicionar um elemento de pagamento por formulário. Move o existente para a página pretendida.');
            return;
        }
        createElementAsync(elementType, true).catch((error) => {
            setSaveStatus('error');
            setToastType('error');
            setToast(error instanceof Error ? error.message : 'Não foi possível criar o campo.');
        });
    }, [createElementAsync]);

    const createTemplate = async (template) => {
        setIsCreatingTemplate(true);
        setSaveStatus('saving');
        setToastType('info');
        setToast('A criar e preencher o modelo. Aguarda um instante...');

        try {
            for (const field of template.fields) {
                const fieldPage = field.pageNumber ?? activePage;
                const createdElement = await createElementAsync(field.type, false, fieldPage);
                const createdElementId = extractElementId(createdElement);

                if (!createdElementId && createdElementId !== 0) {
                    throw new Error(`Não foi possível configurar o campo "${field.label}".`);
                }

                await copyElementConfiguration(
                    {
                        label: field.label ?? '',
                        required: field.required ?? false,
                        element_option: field.element_option ?? [],
                        selection: field.selection ?? false,
                        element_value: field.element_value ?? '',
                        photo: field.photo ?? '',
                        placeholder: field.placeholder ?? '',
                        cost: field.cost ?? 0,
                        donation: field.donation ?? 0,
                        regex: field.regex ?? 'EMPTY',
                        stock: field.stock ?? 0,
                        maxQuantityPerElement: field.maxQuantityPerElement ?? 0,
                        pageNumber: fieldPage,
                    },
                    createdElementId,
                );
                if (field.imageAsset && field.type === 'price') {
                    await uploadTemplateProductImage(createdElementId, field.imageAsset);
                }
            }

            await reloadElements();
            if (template.pages) {
                setMinimumPageCount(template.pages);
                setActivePage(1);
            }

            setSaveStatus('saved');
            setToastType('success');
            setToast('Modelo criado e preenchido. Já podes utilizá-lo ou ajustar os campos.');
        } catch (error) {
            console.error(error);

            await reloadElements();
            setSaveStatus('error');
            setToastType('error');
            setToast(
                error instanceof Error
                    ? error.message
                    : 'Não foi possível criar o modelo. Tenta novamente.',
            );
        } finally {
            setIsCreatingTemplate(false);
        }
    };

    const handleMoveUp = async (index, elementId) => {
        const newPageIndex = index - 1;

        if (newPageIndex < 0) {
            return;
        }

        if (!elementId && elementId !== 0) {
            setToastType('error');
            setToast('Este campo não tem identificador válido.');
            return;
        }

        const reordered = moveElementWithinPage(formElements, activePage, elementId, newPageIndex);
        if (reordered.position < 0) return;
        setFormElements(reordered.elements);

        try {
            await updateHandler(reordered.position, elementId);
        } catch (error) {
            await reloadElements();
            setToastType('error');
            setToast(error instanceof Error ? error.message : 'Não foi possível ordenar o campo.');
        }
    };

    const handleMoveDown = async (index, elementId) => {
        const newPageIndex = index + 1;

        if (newPageIndex >= visibleElements.length) {
            return;
        }

        if (!elementId && elementId !== 0) {
            setToastType('error');
            setToast('Este campo não tem identificador válido.');
            return;
        }

        const reordered = moveElementWithinPage(formElements, activePage, elementId, newPageIndex);
        if (reordered.position < 0) return;
        setFormElements(reordered.elements);

        try {
            await updateHandler(reordered.position, elementId);
        } catch (error) {
            await reloadElements();
            setToastType('error');
            setToast(error instanceof Error ? error.message : 'Não foi possível ordenar o campo.');
        }
    };

    const handleRemove = (index, elementId) => {
        if (!elementId && elementId !== 0) {
            setToastType('error');
            setToast('Este campo não tem identificador válido.');
            return;
        }

        const globalIndex = formElements.findIndex((element) => element.id === elementId);
        const element = globalIndex >= 0 ? formElements[globalIndex] : visibleElements[index];
        if (!element) {
            setToastType('error');
            setToast('Não foi possível localizar o campo selecionado.');
            return;
        }
        setPendingDelete({ index: globalIndex, elementId, element });
    };

    const confirmRemove = async () => {
        if (!pendingDelete) return;
        const { index, elementId, element: elementToRemove } = pendingDelete;
        setPendingDelete(null);
        // Remove by stable ID rather than by the visible page index. The
        // latter differs from the global list on pages 2 and 3 and caused the
        // selected card to remain visible until a reload.
        setFormElements((prevFormElements) => prevFormElements.filter((element) => element.id !== elementId));
        setSaveStatus('saving');

        try {
            await deleteHandler(elementId);
            setSaveStatus('saved');
            setUndoDelete({ element: elementToRemove, index });
            setToastType('success');
            setToast('Campo removido. Usa “Desfazer” se foi por engano.');
        } catch (error) {
            setFormElements((prevFormElements) => {
                const restored = [...prevFormElements];
                restored.splice(Math.max(0, Math.min(index, restored.length)), 0, elementToRemove);
                return restored;
            });
            setSaveStatus('error');
            setToastType('error');
            setToast(error instanceof Error ? error.message : 'Não foi possível remover o campo.');
        }
    };

    const undoLastDelete = async () => {
        if (!undoDelete) return;
        const snapshot = undoDelete;
        setUndoDelete(null);
        setSaveStatus('saving');
        try {
            const created = await createElementAsync(snapshot.element.element_type, false);
            if (!created?.id) throw new Error('Não foi possível restaurar o campo.');
            const updated = normaliseElement(await copyElementConfiguration(snapshot.element, created.id));
            setFormElements((previous) => {
                const withoutCreated = previous.filter((item) => item.id !== created.id);
                withoutCreated.splice(Math.max(0, Math.min(snapshot.index, withoutCreated.length)), 0, { ...created, ...updated, id: created.id });
                return withoutCreated;
            });
            await updateHandler(snapshot.index, created.id);
            setSaveStatus('saved');
            setToastType('success');
            setToast('Campo restaurado com sucesso.');
        } catch (error) {
            setSaveStatus('error');
            setToastType('error');
            setToast(error instanceof Error ? error.message : 'Não foi possível restaurar o campo.');
        }
    };

    const handleDragStart = (_event, index, elementId) => {
        if (!elementId && elementId !== 0) {
            setDraggedIndex(null);
            setDraggedElementId(null);
            return;
        }

        setDraggedIndex(index);
        setDraggedElementId(elementId);
    };

    const handleDragOver = (event, index) => {
        event.preventDefault();

        if (draggedIndex === null || draggedIndex === index) {
            return;
        }

        setFormElements((prevFormElements) => {
            const reordered = moveElementWithinPage(
                prevFormElements,
                activePage,
                draggedElementId,
                index,
            );
            formElementsRef.current = reordered.elements;
            return reordered.elements;
        });

        setDraggedIndex(index);
    };

    const handleDragEnd = async () => {
        if (!draggedElementId && draggedElementId !== 0) {
            setDraggedIndex(null);
            setDraggedElementId(null);
            return;
        }

        const newIndex = formElementsRef.current.findIndex(
            (element) => element.id === draggedElementId,
        );

        if (newIndex >= 0) {
            try {
                await updateHandler(newIndex, draggedElementId);
            } catch (error) {
                await reloadElements();
                setToastType('error');
                setToast(error instanceof Error ? error.message : 'Não foi possível ordenar o campo.');
            }
        }

        setDraggedIndex(null);
        setDraggedElementId(null);
    };

    const handleButtonClick = () => {
        if (nextDisabled) {
            setToastType('info');
            setToast(nextHint);
            return;
        }

        navigate(`${baseFormPath}/formwizard/2`);
    };

    const elementEditPath = (elementId) => {
        if (!elementId && elementId !== 0) {
            return `${baseFormPath}/formwizard/1`;
        }

        return `${baseFormPath}/formelements/${elementId}/wizard`;
    };

    if (loading === true) {
        return <Spinner />;
    }

    return (
        <div className="min-h-screen bg-slate-50 p-5 text-slate-900">
            <StepHeader
                activeStep={0}
                onBack={() => navigate(formsListPath)}
                onNext={handleButtonClick}
                nextDisabled={nextDisabled}
                nextHint={nextHint}
                isCreatingTemplate={isCreatingTemplate}
            />

            {showOnboarding && (
                <section className="mt-5 flex flex-col gap-4 rounded-2xl border border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-950 shadow-sm lg:flex-row lg:items-center lg:justify-between" aria-label="Introdução ao criador de formulários">
                    <div>
                        <strong>Primeiros passos:</strong> adiciona um campo, usa o lápis para o configurar e confirma o estado à direita antes de avançar. Todas as ações são guardadas automaticamente.
                    </div>
                    <button type="button" className="shrink-0 rounded-xl bg-emerald-800 px-4 py-2 font-bold text-white hover:bg-emerald-900" onClick={dismissOnboarding}>Percebi</button>
                </section>
            )}

            <div className="mt-6 grid grid-cols-1 items-start gap-4 lg:grid-cols-[240px_minmax(0,1fr)] xl:grid-cols-[250px_minmax(0,1fr)_260px]">
                <aside className="rounded-2xl border border-slate-200 bg-white shadow-sm lg:sticky lg:top-[218px]">
                    <button
                        type="button"
                        className="flex w-full items-center justify-between border-b border-slate-100 px-4 py-3 text-left"
                        onClick={() => setShowNav((prev) => !prev)}
                        aria-expanded={showNav}
                        aria-controls="form-element-library"
                    >
                        <div>
                            <p className="text-base font-bold text-slate-900">
                                Elementos
                            </p>

                            <p className="text-xs text-slate-500">
                                Clica para adicionar ao formulário
                            </p>
                        </div>

                        {showNav ? <KeyboardArrowLeftIcon /> : <KeyboardArrowRightIcon />}
                    </button>

                    {showNav && (
                        <div id="form-element-library" className="max-h-[calc(100vh-290px)] space-y-3 overflow-y-auto p-3">
                            <label className="relative block">
                                <span className="sr-only">Pesquisar campos</span>
                                <SearchIcon className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" fontSize="small" />
                                <input
                                    type="search"
                                    value={fieldSearch}
                                    onChange={(event) => setFieldSearch(event.target.value)}
                                    placeholder="Pesquisar campos…"
                                    className="w-full rounded-xl border border-slate-200 bg-slate-50 py-2.5 pl-10 pr-3 text-sm outline-none transition focus:border-emerald-500 focus:ring-2 focus:ring-emerald-100"
                                />
                            </label>
                            {filteredElementGroups.map((group) => (
                                <section key={group.title}>
                                    <p className="mb-1 px-2 text-[10px] font-bold uppercase tracking-[0.16em] text-slate-400">
                                        {group.title}
                                    </p>

                                    <div className="space-y-0.5">
                                        {group.items.map((element) => (
                                            <FieldButton
                                                key={element.type}
                                                element={element}
                                                onClick={() => createElement(element.type)}
                                                disabled={isCreatingTemplate}
                                            />
                                        ))}
                                    </div>
                                </section>
                            ))}
                            {filteredElementGroups.length === 0 && (
                                <p className="rounded-xl bg-slate-50 p-4 text-center text-sm text-slate-500">Nenhum campo corresponde à pesquisa.</p>
                            )}
                        </div>
                    )}
                </aside>

                <Context.Provider value={memoizedValue}>
                    <main className="min-h-[620px] min-w-0 rounded-2xl border border-slate-200 bg-white p-4 shadow-sm lg:col-start-2 xl:col-start-auto">
                        <div className="mb-5 flex flex-col gap-3 border-b border-slate-100 pb-5 lg:flex-row lg:items-center lg:justify-between">
                            <div>
                                <p className="text-xs font-semibold uppercase tracking-[0.22em] text-emerald-700">
                                    Pré-visualização
                                </p>

                                <h2 className="text-xl font-bold text-slate-900">
                                    O teu formulário
                                </h2>

                                <p className="text-sm text-slate-500">
                                    Arrasta para ordenar. Usa o lápis para editar cada campo.
                                </p>
                            </div>

                            <div className="flex flex-wrap items-center gap-2">
                                <div className="inline-flex rounded-xl border border-slate-200 bg-slate-50 p-1" aria-label="Tamanho da pré-visualização">
                                    <button type="button" aria-label="Pré-visualização em computador" aria-pressed={previewMode === 'desktop'} onClick={() => setPreviewMode('desktop')} className={`rounded-lg p-1.5 ${previewMode === 'desktop' ? 'bg-white text-emerald-700 shadow-sm' : 'text-slate-400'}`}><DesktopWindowsIcon fontSize="small" /></button>
                                    <button type="button" aria-label="Pré-visualização em telemóvel" aria-pressed={previewMode === 'mobile'} onClick={() => setPreviewMode('mobile')} className={`rounded-lg p-1.5 ${previewMode === 'mobile' ? 'bg-white text-emerald-700 shadow-sm' : 'text-slate-400'}`}><SmartphoneIcon fontSize="small" /></button>
                                </div>
                                <div className={`flex items-center gap-2 rounded-full px-3 py-2 text-xs font-semibold ${saveStatus === 'error' ? 'bg-red-50 text-red-700' : saveStatus === 'saving' ? 'bg-amber-50 text-amber-700' : 'bg-emerald-50 text-emerald-700'}`} role="status" aria-live="polite">
                                    <CheckCircleOutlineIcon fontSize="small" />
                                    {saveStatus === 'saving' ? 'A guardar…' : saveStatus === 'error' ? 'Erro ao guardar' : 'Guardado'}
                                </div>
                                <div className="flex items-center gap-2 rounded-full bg-slate-100 px-3 py-2 text-xs font-semibold text-slate-600">
                                    <PreviewIcon fontSize="small" />
                                    {formElements.length} {formElements.length === 1 ? 'campo' : 'campos'}
                                </div>
                            </div>
                        </div>

                        <nav className="mb-5 flex flex-wrap items-center gap-2 rounded-2xl border border-slate-200 bg-slate-50 p-2" aria-label="Páginas do formulário">
                            {Array.from({ length: pageCount }, (_, index) => index + 1).map((page) => (
                                <button key={page} type="button" onClick={() => setActivePage(page)} aria-current={activePage === page ? 'page' : undefined} className={`rounded-xl px-4 py-2 text-sm font-bold transition ${activePage === page ? 'bg-emerald-700 text-white shadow-sm' : 'bg-white text-slate-600 hover:bg-emerald-50 hover:text-emerald-800'}`}>Página {page}</button>
                            ))}
                            {pageCount < 3 && <button type="button" onClick={addPage} className="rounded-xl border border-dashed border-emerald-400 px-4 py-2 text-sm font-bold text-emerald-700 hover:bg-emerald-50">+ Página</button>}
                            {pageCount > 1 && <button type="button" onClick={removeActivePage} className="inline-flex items-center gap-1 rounded-xl border border-red-200 bg-white px-3 py-2 text-sm font-bold text-red-600 hover:bg-red-50" aria-label={`Remover Página ${activePage}`}><DeleteOutlineIcon fontSize="small" />Remover página</button>}
                            <span className="ml-auto text-xs text-slate-500">Máximo: 3 páginas</span>
                        </nav>

                        {visibleElements.length === 0 ? (
                            <div className="flex min-h-[480px] items-center justify-center rounded-3xl border-2 border-dashed border-slate-200 bg-slate-50 p-6">
                                <div className="w-full max-w-4xl text-center">
                                    <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-3xl bg-emerald-100 text-emerald-700">
                                        <AutoAwesomeIcon />
                                    </div>

                                    <h3 className="mt-5 text-2xl font-bold text-slate-900">
                                        {hasElements ? `Começa a Página ${activePage} com um modelo` : 'Começa com um modelo'}
                                    </h3>

                                    <p className="mx-auto mt-2 max-w-2xl text-sm text-slate-500">
                                        {hasElements
                                            ? 'Escolhe um ponto de partida para esta página. Os campos das outras páginas não serão alterados.'
                                            : 'Evita o ecrã vazio: escolhe um ponto de partida e depois ajusta os campos ao teu caso.'}
                                    </p>

                                    <div className={`mt-6 grid gap-4 ${hasElements ? 'md:grid-cols-3' : 'md:grid-cols-2 xl:grid-cols-3'}`}>
                                        {(hasElements ? PAGE_TEMPLATES : COMPLETE_TEMPLATES).map((template) => (
                                            <button
                                                key={template.title}
                                                type="button"
                                                className="group overflow-hidden rounded-3xl border border-slate-200 bg-white text-left shadow-sm transition hover:-translate-y-1 hover:border-emerald-300 hover:shadow-lg disabled:cursor-not-allowed disabled:opacity-60"
                                                onClick={() => createTemplate(template)}
                                                disabled={isCreatingTemplate}
                                            >
                                                {template.image && <img src={template.image} alt="" className="h-36 w-full object-cover transition duration-300 group-hover:scale-[1.03]" />}
                                                <div className="p-5">
                                                    <span className="rounded-full bg-emerald-50 px-3 py-1 text-xs font-bold text-emerald-700">{template.badge}</span>
                                                    <h4 className="mt-4 text-base font-bold text-slate-900">{template.title}</h4>
                                                    <p className="mt-2 text-sm leading-6 text-slate-500">{template.description}</p>
                                                    {template.pages && <p className="mt-3 text-xs font-semibold text-emerald-700">{template.pages} páginas · conteúdo completo</p>}
                                                </div>
                                            </button>
                                        ))}
                                    </div>

                                    <div className="mt-6 flex flex-wrap justify-center gap-3">
                                        <button
                                            type="button"
                                            className="inline-flex items-center gap-2 rounded-xl border border-slate-300 bg-white px-4 py-2 text-sm font-semibold text-slate-700 shadow-sm transition hover:bg-slate-100 disabled:cursor-not-allowed disabled:opacity-60"
                                            onClick={() => createElement('input')}
                                            disabled={isCreatingTemplate}
                                        >
                                            <AddCircleOutlineIcon fontSize="small" />
                                            Começar vazio
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <form className={`mx-auto w-full space-y-3 transition-all ${previewMode === 'mobile' ? 'max-w-[390px] overflow-hidden rounded-[2.5rem] border-[8px] border-slate-800 bg-slate-50 p-2.5 shadow-xl' : 'max-w-none space-y-4'}`} onSubmit={(event) => event.preventDefault()}>
                                {visibleElements.map((formElement, i) => {
                                    const elementId = extractElementId(formElement);
                                    const canEdit = !!elementId || elementId === 0;

                                    return (
                                        <div
                                            key={elementId ?? `element-${i}`}
                                            className={`group relative min-w-0 overflow-hidden border border-slate-200 bg-white shadow-sm transition hover:border-emerald-200 hover:shadow-md ${previewMode === 'mobile' ? 'rounded-[1.4rem] p-3' : 'rounded-3xl p-4'}`}
                                            draggable={canEdit}
                                            onDragStart={(event) =>
                                                handleDragStart(event, i, elementId)
                                            }
                                            onDragOver={(event) => handleDragOver(event, i)}
                                            onDragEnd={handleDragEnd}
                                        >
                                            <div className="absolute -left-3 top-1/2 hidden -translate-y-1/2 cursor-grab rounded-xl border border-slate-200 bg-white p-1 text-slate-400 shadow-sm group-hover:block" aria-hidden="true">
                                                <DragIndicatorIcon fontSize="small" />
                                            </div>

                                            <div className="absolute right-3 top-3 z-10 flex items-center gap-1 rounded-2xl border border-slate-200 bg-white/95 p-1 opacity-100 shadow-sm lg:opacity-0 lg:transition lg:group-hover:opacity-100">
                                                <button
                                                    className="rounded-xl p-2 text-slate-500 transition hover:bg-slate-100 hover:text-slate-800 disabled:opacity-30"
                                                    type="button"
                                                    onClick={() => handleMoveUp(i, elementId)}
                                                    disabled={i === 0 || !canEdit}
                                                    title="Mover para cima"
                                                >
                                                    <ArrowUpwardIcon fontSize="small" />
                                                </button>

                                                <button
                                                    className="rounded-xl p-2 text-slate-500 transition hover:bg-slate-100 hover:text-slate-800 disabled:opacity-30"
                                                    type="button"
                                                    onClick={() => handleMoveDown(i, elementId)}
                                                    disabled={i === formElements.length - 1 || !canEdit}
                                                    title="Mover para baixo"
                                                >
                                                    <ArrowDownwardIcon fontSize="small" />
                                                </button>

                                                {canEdit ? (
                                                    <Link to={elementEditPath(elementId)} className="rounded-xl p-2 text-slate-500 transition hover:bg-emerald-50 hover:text-emerald-700" title="Editar campo" aria-label="Editar campo">
                                                        <span
                                                            className="rounded-xl p-2 text-slate-500 transition hover:bg-emerald-50 hover:text-emerald-700"
                                                        >
                                                            <EditIcon fontSize="small" />
                                                        </span>
                                                    </Link>
                                                ) : (
                                                    <button
                                                        className="rounded-xl p-2 text-slate-300"
                                                        type="button"
                                                        title="Campo sem identificador"
                                                        disabled
                                                    >
                                                        <EditIcon fontSize="small" />
                                                    </button>
                                                )}

                                                <button
                                                    className="rounded-xl p-2 text-slate-500 transition hover:bg-sky-50 hover:text-sky-700 disabled:opacity-30"
                                                    type="button"
                                                    onClick={() => duplicateElement(formElement)}
                                                    disabled={!canEdit || saveStatus === 'saving'}
                                                    title="Duplicar campo"
                                                    aria-label="Duplicar campo"
                                                >
                                                    <ContentCopyIcon fontSize="small" />
                                                </button>

                                                <button
                                                    className="rounded-xl p-2 text-red-500 transition hover:bg-red-50 disabled:text-red-200"
                                                    type="button"
                                                    onClick={() => handleRemove(i, elementId)}
                                                    disabled={!canEdit}
                                                    title="Remover campo"
                                                    aria-label="Remover campo"
                                                >
                                                    <DeleteOutlineIcon fontSize="small" />
                                                </button>
                                            </div>

                                            <div className={`${previewMode === 'mobile' ? '[&>div]:!m-0 [&>div]:!max-w-full [&>div]:!w-full' : 'pr-0 lg:pr-40'}`}>
                                                <Element
                                                    i={i}
                                                    formElement={{
                                                        ...formElement,
                                                        id: elementId,
                                                    }}
                                                    formId={idform}
                                                    compact={previewMode === 'mobile'}
                                                />
                                            </div>
                                            <label className="mt-3 flex items-center gap-2 text-xs font-semibold text-slate-500">Página
                                                <select value={formElement.pageNumber || 1} onChange={(event) => moveElementToPage(formElement, Number(event.target.value))} className="rounded-lg border border-slate-200 bg-white px-2 py-1">
                                                    {[1, 2, 3].map((page) => <option key={page} value={page}>{page}</option>)}
                                                </select>
                                            </label>
                                        </div>
                                    );
                                })}
                            </form>
                        )}
                    </main>
                </Context.Provider>

                <aside className="space-y-4 lg:col-span-2 lg:grid lg:grid-cols-2 lg:gap-4 lg:space-y-0 xl:col-span-1 xl:block xl:space-y-4 xl:sticky xl:top-[218px]">
                    <section className="rounded-3xl border border-slate-200 bg-white p-5 shadow-sm">
                        <div className="flex items-center gap-3">
                            <div className="flex h-10 w-10 items-center justify-center rounded-2xl bg-slate-100 text-slate-700">
                                <Settings />
                            </div>

                            <div>
                                <h3 className="font-bold text-slate-900">
                                    Estado do formulário
                                </h3>

                                <p className="text-xs text-slate-500">
                                    Requisitos para avançar
                                </p>
                            </div>
                        </div>

                        <div className="mt-4 space-y-2">
                            <SummaryItem ok={hasElements} label="Tem campos adicionados" />

                            <div className="flex items-center justify-between rounded-xl bg-slate-50 px-3 py-2 text-sm">
                                <span className="text-slate-600">
                                    Pagamento
                                </span>

                                <span className="rounded-full bg-slate-200 px-2 py-0.5 text-xs font-bold text-slate-700">
                                    {hasPaymentElement ? 'Incluído' : 'Opcional'}
                                </span>
                            </div>
                        </div>

                        {nextDisabled ? (
                            <div className="mt-4 rounded-2xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-800">
                                {nextHint}
                            </div>
                        ) : (
                            <div className="mt-4 rounded-2xl border border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-800">
                                Está pronto para configurares as definições, os pagamentos opcionais e a publicação.
                            </div>
                        )}
                    </section>

                    <section className="rounded-3xl border border-slate-200 bg-white p-5 shadow-sm">
                        <h3 className="font-bold text-slate-900">
                            Atalhos rápidos
                        </h3>

                        <div className="mt-4 space-y-2">
                            <button
                                type="button"
                                className="w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-left text-sm font-semibold text-slate-700 transition hover:bg-white hover:shadow-sm disabled:cursor-not-allowed disabled:opacity-60"
                                onClick={() => createElement('price')}
                                disabled={isCreatingTemplate}
                            >
                                + Produto / bilhete com preço
                            </button>

                            <button
                                type="button"
                                className="w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-left text-sm font-semibold text-slate-700 transition hover:bg-white hover:shadow-sm disabled:cursor-not-allowed disabled:opacity-60"
                                onClick={() => createElement('donation')}
                                disabled={isCreatingTemplate}
                            >
                                + Campo de donativo
                            </button>

                            <button
                                type="button"
                                className="w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-left text-sm font-semibold text-slate-700 transition hover:bg-white hover:shadow-sm disabled:cursor-not-allowed disabled:opacity-60"
                                onClick={() => createElement('textblock')}
                                disabled={isCreatingTemplate}
                            >
                                + Bloco informativo
                            </button>
                        </div>
                    </section>
                </aside>
            </div>

            <Toast
                type={toastType}
                message={toast}
                onClose={() => setToast('')}
                actionLabel={undoDelete && toastType === 'success' && toast.startsWith('Campo removido') ? 'Desfazer' : undefined}
                onAction={undoLastDelete}
            />
            <ConfirmDialog
                open={Boolean(pendingDelete)}
                fieldName={pendingDelete?.element?.label || pendingDelete?.element?.placeholder}
                onCancel={() => setPendingDelete(null)}
                onConfirm={confirmRemove}
            />
            <ConfirmPageDeleteDialog
                open={Boolean(pendingPageDelete)}
                pageNumber={pendingPageDelete?.pageNumber}
                fieldCount={pendingPageDelete?.elements?.length || 0}
                onCancel={() => setPendingPageDelete(null)}
                onConfirm={confirmRemovePage}
            />
        </div>
    );
};

export default FormWizard1;
